import React from 'react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Actions} from '../../../common/actions';
import {Card, Header, Dropdown} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {dealerListMaintain} from '../../../common/constants/lists';
import Loading from '../../../common/components/loader';
import './styles.scss';
import Table from './maintainTable';


class MaintainSaleForecast extends React.Component {
  state = {
    'dealer': '',
    'columns': [
      {
        'Header': 'CÓDIGO',
        'accessor': 'code',
      },
      {
        'Header': 'AGENCIA',
        'accessor': 'name',
      },
      {
        'Header': 'DIRECCIÓN',
        'accessor': 'address',
      },
      {
        'Header': 'PROVINCIA',
        'accessor': 'province',
      },
      {
        'Header': 'CIUDAD',
        'accessor': 'city',
      },
      {
        'Header': 'TELEFONO',
        'accessor': 'phone',
      },
      {
        'Header': 'ESTADO',
        'accessor': 'status',
        'Cell': (cell) => {
          const status = cell.row.original.status === 'A' ? 'ACTIVO' : 'INACTIVO';
          return (<span>{status}</span>);
        },
        'Filter': ({'column': {filterValue, setFilter}}) => null,
      },
      {
        'Header': 'APLICA PARA KPI',
        'accessor': 'kpiVehicle',
        'Cell': (cell) => {
          const selectedRow = cell.row.original;
          const status = cell.row.original.kpiVehicle;
          return (
            <select value={status}
              className="select-vehicles-maintain"
              onChange={(e) => this.handleChange(selectedRow, e)}>
              <option value='S'>SI</option>
              <option value='N'>NO</option>
            </select>
          );
        },
        'Filter': ({'column': {filterValue, setFilter}}) => null,
      },
    ],
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.MaintainSaleForecast, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
  }

  componentWillUnmount() {
    this.props.clearMaintainForecastAgenciesList();
  }

  onSearchDealerByAgency = (value) => {
    this.props.fetchAgenciesByDealerAll(value);
    this.setState({'dealer': value});
  }

  handleChange = (row, event) => {
    const {dealer, code} = row;
    const value = event.target.value;
    const data = {
      dealer, code, 'status': value,
    };
    this.props.updateAgencyStatus(data);
  }

  render() {
    const {columns, dealer} = this.state;
    const {loading, agencies} = this.props;

    if (loading) {
      return <Loading/>;
    }

    return (
      <div className="maintain-sale-forecast-container">
        <Card raised fluid>
          <div className="maintain-sale-forecast-container-header">
            <Header as="h2">Mantenimientos de Agencias </Header>
            <div className="maintain-sale-forecast-container-select">
              <label htmlFor="dealer">Selección de dealer</label>
              <Dropdown
                placeholder='SELECCIONAR DEALER'
                fluid
                selection
                value={dealer}
                onChange={(e, {value}) => this.onSearchDealerByAgency(value) }
                options={dealerListMaintain}
              />
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <div className="maintain-sale-forecast-container-table">
            <Table columns={columns} data={agencies} />
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'loading': state.agenciesComplete.loading,
    'agencies': state.agenciesComplete.list,
  };
};

const {
  fetchAgenciesByDealerAll,
  updateAgencyStatus,
  clearMaintainForecastAgenciesList,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  fetchAgenciesByDealerAll,
  updateAgencyStatus,
  clearMaintainForecastAgenciesList,
})(MaintainSaleForecast));
